export let MediaFormat;(function(a){a.Avif="avif",a.Webp="webp",a.Jpeg="jpeg",a.Png="png",a.All="all"})(MediaFormat||(MediaFormat={}));